const mEditionBillingUsersMonitoring = {
  mEditionBillingUsersMonitoring: {
    alerts: {
      updateAcademiaActorEstado: {
        activationSuccess: 'El rol de usuario fue activado exitosamente.',
        deactivationSuccess: 'El rol de usuario fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    messages: {
      activeSince: 'Activo desde',
      noContact: 'sin información de contacto',
      noData: 'No hay datos disponibles',
      mobile: 'Móvil',
      noLegal: 'sin información legal',
      noLocation: 'sin información de ubicación',
      noNumber: 'sin número',
      phone: 'Teléfono',
      wrongEmail: 'El email ingresado no pertenece a un usuario registrado'
    },

    title: 'ROLES DE USUARIO',
    titleAssets: 'ACADEMIAS'
  }
}

export default mEditionBillingUsersMonitoring
